export default "__VITE_ASSET__9fb2bc6e__"